<section class="verification-step subscription-plans" aria-labelledby="subscription-plans-title">
  <h1 class="verification-page-title">{{ 'ONBOARDING.TITLE.0' | translate }}</h1>
  <div class="verification-intro subscription-plans__header">
    <span class="verification-icon subscription-plans__brand-mark" aria-hidden="true">B</span>
    <h2 id="subscription-plans-title" class="subscription-plans__title">
      {{ "SUBSCRIPTION_PLANS.HEADING" | translate }}
    </h2>
    <p class="verification-description subscription-plans__subtitle">{{ "SUBSCRIPTION_PLANS.SUBHEADING" | translate }}</p>
  </div>

  <div class="subscription-plans__grid">
    <article
      class="subscription-plan-card subscription-plan-card--annual subscription-plan-card--recommended"
      [class.subscription-plan-card--selected]="selectedPlan() === 'annual'"
      (click)="selectPlan('annual')">
      <button
        type="button"
        class="subscription-plan-card__select"
        [attr.aria-pressed]="selectedPlan() === 'annual'"
        (click)="selectPlan('annual')">
        <span class="subscription-plan-card__radio" aria-hidden="true"></span>
        <span class="sr-only">{{ "SUBSCRIPTION_PLANS.ANNUAL.TITLE" | translate }}</span>
      </button>

      <p class="subscription-plan-card__eyebrow">{{ "SUBSCRIPTION_PLANS.ANNUAL.BADGE" | translate }}</p>
      <h3 class="subscription-plan-card__name">
        <fa-icon [icon]="faCrown" aria-hidden="true"></fa-icon>
        <span>{{ "SUBSCRIPTION_PLANS.ANNUAL.TITLE" | translate }}</span>
      </h3>

      <p class="subscription-plan-card__price">
        <span>€99.00</span>
        <span>/ {{ "SUBSCRIPTION_PLANS.ANNUAL.SUBTITLE" | translate }}</span>
      </p>
      <p class="subscription-plan-card__description">{{ "SUBSCRIPTION_PLANS.ANNUAL.DESCRIPTION" | translate }}</p>

      <ul class="subscription-plan-card__features">
        @for (featureKey of featureKeys; track featureKey) {
        <li>
          <fa-icon [icon]="faCheck" aria-hidden="true"></fa-icon>
          <span>{{ featureKey | translate }}</span>
        </li>
        }
      </ul>

      <button
        type="button"
        class="subscription-plan-card__button subscription-plan-card__button--primary"
        (click)="subscribeYearly()"
        [disabled]="disableButtons() || isSubscriptionInProgress()">
        {{ "SUBSCRIPTION_PLANS.ANNUAL.CTA" | translate }}
      </button>
    </article>

    <article
      class="subscription-plan-card subscription-plan-card--quarterly"
      [class.subscription-plan-card--selected]="selectedPlan() === 'quarterly'"
      (click)="selectPlan('quarterly')">
      <button
        type="button"
        class="subscription-plan-card__select"
        [attr.aria-pressed]="selectedPlan() === 'quarterly'"
        (click)="selectPlan('quarterly')">
        <span class="subscription-plan-card__radio" aria-hidden="true"></span>
        <span class="sr-only">{{ "SUBSCRIPTION_PLANS.QUARTERLY.TITLE" | translate }}</span>
      </button>

      <p class="subscription-plan-card__eyebrow">{{ "SUBSCRIPTION_PLANS.QUARTERLY.BADGE" | translate }}</p>
      <h3 class="subscription-plan-card__name">
        <fa-icon [icon]="faStar" aria-hidden="true"></fa-icon>
        <span>{{ "SUBSCRIPTION_PLANS.QUARTERLY.TITLE" | translate }}</span>
      </h3>

      <p class="subscription-plan-card__price">
        <span>€29.00</span>
        <span>/ {{ "SUBSCRIPTION_PLANS.QUARTERLY.SUBTITLE" | translate }}</span>
      </p>
      <p class="subscription-plan-card__description">{{ "SUBSCRIPTION_PLANS.QUARTERLY.DESCRIPTION" | translate }}</p>

      <ul class="subscription-plan-card__features">
        @for (featureKey of featureKeys; track featureKey) {
        <li>
          <fa-icon [icon]="faCheck" aria-hidden="true"></fa-icon>
          <span>{{ featureKey | translate }}</span>
        </li>
        }
      </ul>

      <button
        type="button"
        class="subscription-plan-card__button subscription-plan-card__button--secondary"
        (click)="subscribeQuarterly()"
        [disabled]="disableButtons() || isSubscriptionInProgress()">
        {{ "SUBSCRIPTION_PLANS.QUARTERLY.CTA" | translate }}
      </button>
    </article>
  </div>

  <button
    type="button"
    class="subscription-plans__mobile-cta"
    (click)="subscribeSelectedPlan()"
    [disabled]="disableButtons() || isSubscriptionInProgress()">
    {{ "SUBSCRIPTION_PLANS.MOBILE_CTA" | translate }}
  </button>
</section>
